import React, { useEffect, useState } from "react";
import CollapseSection from "../../../collapse/CollapseSection";
import { Grid2 } from "@mui/material";
import TextInput from "../../../input/TextInput";
import { getProfile } from "../../../../../redux/actions/auth.action";
import { useSelector } from "react-redux";
import { ID_APP } from "../../../../../utils/constants";
import DateInput from "../../../input/DateInput";

interface IProfileSection {
  data: any;
}

function ProfileSection({ data }: IProfileSection) {
  const { token } = useSelector((state: any) => state.auth);
  const [show, setShow] = useState<boolean>(true);
  const [profileData, setProfileData] = useState<any>();

  const getProfileData = async () => {
    const resp = await getProfile({ token, email: data?.email, idApp: ID_APP });
    setProfileData(resp?.data);
  };

  useEffect(() => {
    getProfileData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CollapseSection
      show={show}
      title="Thông tin người dùng"
      onCollapse={() => setShow(!show)}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 6 }}>
          <TextInput
            readOnly
            value={profileData?.name}
            label="Họ tên"
            labelWidth="25%"
            placeholder="Tên đầy đủ"
          />
        </Grid2>
        <Grid2 size={{ xs: 6 }}>
          <TextInput
            readOnly
            value={profileData?.phone}
            label="Điện thoại"
            labelWidth="25%"
            placeholder="Số điện thoại người dùng"
          />
        </Grid2>
        <Grid2 size={{ xs: 6 }}>
          <DateInput
            readOnly
            label="Ngày sinh"
            labelWidth="25%"
            value={profileData?.exfields?.dob}
            onChange={() => {}}
          />
        </Grid2>
        <Grid2 size={{ xs: 6 }}>
          <TextInput
            readOnly
            value={profileData?.exfields?.province?.ten_tinh_thanh}
            label="Tỉnh thành"
            labelWidth="25%"
            placeholder="Tỉnh thành"
          />
        </Grid2>
        <Grid2 size={{ xs: 6 }}>
          <TextInput
            readOnly
            value={profileData?.exfields?.district?.ten_quan_huyen}
            label="Quận huyện"
            labelWidth="25%"
            placeholder="Quận huyện"
          />
        </Grid2>
        <Grid2 size={{ xs: 6 }}>
          <TextInput
            readOnly
            value={profileData?.exfields?.district?.ten_xa_phuong}
            label="Xã phường"
            labelWidth="25%"
            placeholder="Xã phường"
          />
        </Grid2>
      </Grid2>
    </CollapseSection>
  );
}

export default ProfileSection;
